import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@collaborate-health/uikit'
import { IdentityUserDto } from '@tabeeb/contracts/identity-server/swagger-identity-service'
import SwitchTenantContent from '@tabeeb/modules/account/components/SwitchTenantContent'

export interface SwitchTenantDialogProps {
  open: boolean
  onClose: () => void
  identityMe: IdentityUserDto
}

const SwitchTenantDialog: React.FC<SwitchTenantDialogProps> = ({ open, onClose, identityMe }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Available Tenants</DialogTitle>
      <DialogContent>
        <SwitchTenantContent identityMe={identityMe} dialog />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default SwitchTenantDialog

